import { ValidatorFn, Validators } from '@angular/forms';

const PATTERN = /^[A-Za-zÀ-ÖØ-öø-ÿ -]+$/;

export const cardHolderName: ValidatorFn = (control) =>
  Validators.pattern(PATTERN)(control)
    ? { cardHolderName: control.value }
    : null;
